// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"17bf26e5","631":"08b8d5d8","797":"5d84b1c9","828":"65da1585","882":"bbc00015"}[chunkId] + ".chunk.js";
};